import React, { useContext, useEffect, useState } from 'react'
import {Divider, Grid, Loader} from 'semantic-ui-react'
import RequestReviewList from './RequestReviewList'
import { observer } from 'mobx-react-lite'
import LoadingComponent from '../../../../App/layout/LoadingComponent'
import { RootStoreContext } from '../../../../App/stores/RootStore'
import RequestReviewFilters from './RequestReviewFilters'
import RequestReviewListTable from "./RequestReviewListTable";

const RequestReviewDashboard: React.FC = () => {
    const rootStore = useContext(RootStoreContext)

    const { loadTableRequestReviews, clearRequestReviews, loadingInitial, setPage, page,  } = rootStore.requestReviewStore;
    const [, setLoadingNext] = useState(false);

    const handleGetNext = () => {
        setLoadingNext(true);
        setPage(page + 1);
        loadTableRequestReviews().then(() => setLoadingNext(false))
    }

    useEffect(() => {
        clearRequestReviews();
        loadTableRequestReviews();
    }, [loadTableRequestReviews, clearRequestReviews]);

    return (
        <>
            <RequestReviewFilters />
            <Divider/>
            <LoadingComponent active={loadingInitial} content='Loading Requests Reviews...' />
            <RequestReviewListTable />
        </>
    )
}
export default observer(RequestReviewDashboard);